import API from "@/models/API";

export default class StoreSubscriptions {
    constructor(item = {}) {
        
    }

    static get = (body) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions${body.query}`);
        
    static getExportedFileStatus = () =>
    API.get(
        `/companies/${localStorage.getItem(
            "storeId"
        )}/export/subscriptions`
    );

    static exportFile = item =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/subscriptions`,
            item
        );

    static deleteExportedFile = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/subscriptions/${id}`
    );

    static updateSettings = payload =>
        API.patch(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/subscriptions/${payload.id}/settings`, payload.body
    );


}
